/** Frontmatter for the "week5-waiver-wire-darkness-report" article; the Body lives in week5-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week5-waiver-wire-darkness-report',
  title: 'Week 5 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt:
    'Emanuel Wilson, Will Shipley and Keon Coleman lead a Week 5 wire reshaped by Charbonnet, Barkley and DJ Moore. A FAAB ladder, the full board, a superflex corner, a D/ST streaming chart built on implied totals, an IDP board, the injury ledger, a Week 4 report card and the bid sheet.',
  readMinutes: 15,
  date: '2026-10-06',
};

export default meta;
